<template>
    <DataTable
        :data="sortedItems"
        :columns="columns"
        :loading="false"
        enable-sorting
        enable-search
        enable-pagination
        search-placeholder="Search in filtered results"
        @row-click="routeToDetails"
    />
</template>

<script setup lang="ts">
import DataTable from '@/components/tables/DataTable.vue';
import {
    createEmailColumn,
    createResponseTimeColumn,
    createStatusColumn,
    createTextColumn,
} from '@/components/tables/columns/factories';
import { ref } from 'vue';

type MockData = {
    id: number;
    status: string;
    response_time: number;
    summary: string;
    email: string;
};
const sortedItems = ref<MockData[]>([
    {
        id: 1,

        status: 'Done',
        response_time: 0,
        summary:
            'Very long text Very long text Very long text Very long text Very long text Very long text Very long text',
        email: 'very.long.email.very.long.email.very.long.email.very.long.email.very.long.email@atnorth.com',
    },
    {
        id: 2,
        status: 'In progress',
        response_time: 1000000,
        summary:
            'Very long text Very long text Very long text Very long text Very long text Very long text Very long text',
        email: 'very.long.email.very.long.email.very.long.email.very.long.email.very.long.email@atnorth.com',
    },
    {
        id: 2,
        status: 'In progress',
        response_time: 1000000,
        summary:
            'Very long text Very long text Very long text Very long text Very long text Very long text Very long text',
        email: 'very.long.email.very.long.email.very.long.email.very.long.email.very.long.email@atnorth.com',
    },
    {
        id: 2,
        status: 'In progress',
        response_time: 1000000,
        summary:
            'Very long text Very long text Very long text Very long text Very long text Very long text Very long text',
        email: 'very.long.email.very.long.email.very.long.email.very.long.email.very.long.email@atnorth.com',
    },
]);

const columns = [
    createTextColumn<MockData>('id', 'Id'),
    createStatusColumn<MockData>('status'),
    createResponseTimeColumn<MockData>('response_time'),
    createTextColumn<MockData>('summary', 'Summary'),
    createEmailColumn<MockData>('email'),
];

// const sortedItems = ref<{ id: number; summary: string | null | undefined | number }[]>([
//     {
//         id: 1,
//         summary: 'a',
//     },
//     {
//         id: 2,
//         summary: null,
//     },
//     {
//         id: 2,
//         summary: 'C',
//     },
//     {
//         id: 2,
//         summary: 'A',
//     },
// ]);

// const columns = [
//     createTextColumn<Partial<Request>>('id', 'Id'),
//     createTextColumn<Partial<Request>>('summary', 'Summary'),
// ];

const routeToDetails = (row: MockData) => {
    console.log('data table click row: ', row.id, row.status, row.response_time);
};
</script>

<style scoped></style>
